/* eslint-disable import/prefer-default-export */
const MAX_CHAR = 2000;
const SEARCH_LIMIT = 500;

export { MAX_CHAR, SEARCH_LIMIT };
